import colors from 'tailwindcss/colors';

// '#1976d2', // primary MUI color

export const COLORS = {
    calories: colors.sky[400],
    caloriesLight: colors.gray[100],

    macrosLight: colors.gray[100],

    protein: colors.green[600],
    fat: colors.yellow[400],
    carb: colors.orange[400],
    sugar: colors.red[500],

    proteinLight: colors.green[300],
    fatLight: colors.yellow[200],
    carbLight: colors.orange[200],
    sugarLight: colors.red[300],
};

export const CALPAL_THEME = {
    palette: {
        primary: {
            // main: '#1976d2',
            main: colors.green[700],
        },
        secondary: {
            // main: '#ff4081',
            main: colors.sky[700],
        },
        // error: {
        //     main: '#f44336',
        // },
        // warning: {
        //     main: '#ffa726',
        // },
        // info: {
        //     main: '#2196f3',
        // },
        // success: {
        //     main: '#4caf50',
        // },
        // text: {
        //     primary: '#000000',
        //     secondary: '#757575',
        // },
        // background: {
        //     default: '#f5f5f5',
        //     paper: '#ffffff',
        // },
        // divider: '#e0e0e0',
    },
};
